module.exports = __webpack_public_path__ + "sg.svg?76233054b485075671cad0576eb3e0d3";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/sg.svg
// module id = 1124
// module chunks = 27